:host {
  @include scroll-y;
  position: absolute;
  backface-visibility: hidden; // ensure scrolling in Chrome when sdx-select is inside a vertical scrollbar
  background: $color-white;
  z-index: $zindex-topmost;
  border-radius: $border-radius-medium;
}

:host(:not(.inside-dialog)) {
  box-shadow: 0 0 4px 0 rgba($color-gray, 0.1),
    inset 0 0 0 1px $color-gray-tint-6;

  .filter-input-wrapper {
    padding: $baseline;
  }
}

:host(.inside-dialog) {
  position: unset;
  margin-top: -14px; // Fine adjustment

  .filter-input-wrapper {
    padding-bottom: $baseline;
  }
}

:host(:focus) {
  outline: none;
}

// Open/opening towards top
:host(:not(.inside-dialog).open.top),
:host(:not(.inside-dialog).opening.top) {
  border-top: $border-width solid $color-gray-tint-8;

  .component {
    .filter-input-wrapper {
      border-bottom: $border-width solid $color-gray-tint-6;
    }
  }
}

:host(:not(.inside-dialog).open.bottom),
:host(:not(.inside-dialog).opening.bottom) {
  border-bottom: $border-width solid $color-gray-tint-8;
}

// Open/opening/closing towards bottom
:host(.bottom) {
  border-radius: 0 0 $border-radius-medium $border-radius-medium;
}

// Open/opening/closing towards top
:host(.top) {
  border-radius: $border-radius-medium $border-radius-medium 0 0;
}

:host(.is-list-overlapping.bottom.right) {
  border-top-right-radius: $border-radius-medium;
}

:host(.is-list-overlapping.bottom.left) {
  border-top-left-radius: $border-radius-medium;
}

:host(.is-list-overlapping.top.right) {
  border-bottom-right-radius: $border-radius-medium;
}

:host(.is-list-overlapping.top.left) {
  border-bottom-left-radius: $border-radius-medium;
}

.component {
  .no-matches-found {
    height: $select-height;
    display: flex;
    align-items: center;
    padding: 0 $baseline;
    color: $color-int-orange;
  }
}

:host(.sdx--dark-theme) {
  background: $color-dusk-tint-2-dark-theme;
  box-shadow: 0 0 4px 0 rgba($color-int-blue2-dark-theme, 0.1),
    inset 0 0 0 1px $color-int-blue2-dark-theme;
}

:host(.sdx--dark-theme.inside-dialog) {
  background: transparent;
  box-shadow: unset;
}

// Open/opening towards top
:host(.open.top.sdx--dark-theme),
:host(.opening.top.sdx--dark-theme) {
  border-top-color: $color-int-blue2-dark-theme;

  .component {
    .filter-input-wrapper {
      border-bottom-color: $color-gray-tint-7-dark-theme;
    }
  }
}

:host(.open.bottom.sdx--dark-theme),
:host(.opening.bottom.sdx--dark-theme) {
  border-bottom-color: $color-int-blue2-dark-theme;
}

.component.sdx--dark-theme {
  .no-matches-found {
    color: $color-int-orange2-dark-theme;
  }
}
